import { RouteComponentProps, withRouter } from "react-router-dom";
import { ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { Section } from '../../entities/Metadata';
import { BaseSectionsContainer } from '../common/sectionsControl/SectionsContainer/BaseSectionsContainer';
import { actionCreators as UserInterfaceActionCreators, UserInterfaceState } from '../../store/UserInterfaceStore';
import { bindActionCreators } from 'redux';
import { UserState, actionCreators as UserActionCreators } from '../../store/User';
import SettingsPage, { OwnProps as SettingsPageProps } from './SettingsPage';
import { TenantState } from "../../store/Tenant";

type OwnProps = SettingsPageProps & {
    sections: Section[] ,
    settingsKey?: string;
};

type StateProps = { 
    user: UserState;
    userInterface: UserInterfaceState;
    tenant: TenantState;
}

type ActionProps = { userInterfaceActions: typeof UserInterfaceActionCreators, userActions: typeof UserActionCreators };
type Props = OwnProps & StateProps & ActionProps & RouteComponentProps<{}>;;

const SectionableSettingsPage = (props: Props) =>
    <SettingsPage {...props}>
        <div className='settings-section'>
            <BaseSectionsContainer
                entity={{
                    id: props.tenant.id,
                    sections: props.sections
                }}
                userInterface={props.userInterface}
                userInterfaceActions={props.userInterfaceActions}
                history={props.history}
                location={props.location}
                match={props.match}
                isExpanded={props.user.preferences.expandSecondSidebar?.[props.settingsKey!]}
                onExpand={(expanded) => { props.settingsKey && props.userActions.updateSecondSidebarPreferences(props.settingsKey, expanded); }}
            />
        </div>
    </SettingsPage>;

function mapDispatchToProps(dispatch: any) {
    return {
        userActions: bindActionCreators(UserActionCreators, dispatch),
        userInterfaceActions: bindActionCreators(UserInterfaceActionCreators, dispatch)
    };
}

function mapStateToProps(state: ApplicationState, ownProp: OwnProps) {
    return {
        user: state.user,
        userInterface: state.userInterface,
        tenant: state.tenant,
    };
}

export default withRouter<OwnProps>(connect(mapStateToProps, mapDispatchToProps)(SectionableSettingsPage));